'use client'

import React from 'react'
import { Link } from '@/lib/i18n/settings'
import { useTranslations } from '@/lib/next-shim'
import { FAQPage, WithContext } from 'schema-dts'

const faqsArr = [1, 2, 3, 4, 5, 6] as const

export default function FAQs() {
  const t = useTranslations()

  const faqs = faqsArr.map((questionIdx) => ({
    questionName: t(`marketing.sections.FAQs.faqs.${questionIdx}.question`),
    acceptedAnswerText: t(`marketing.sections.FAQs.faqs.${questionIdx}.answer`),
  }))

  const jsonLd: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((question) => ({
      '@type': 'Question',
      name: question.questionName,
      acceptedAnswer: {
        '@type': 'Answer',
        text: question.acceptedAnswerText,
      },
    })),
  }

  return (
    <div id="faqs" className="bg-white">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
        <h2 className="text-3xl font-medium tracking-tight text-gray-900">{t('marketing.sections.FAQs.title')}</h2>
        <p className="mt-2 max-w-3xl text-lg text-gray-600">
          {t.rich('marketing.sections.FAQs.subtitle', {
            link: (chunks: React.ReactNode) => (
              <Link href={`mailto:${t('marketing.sections.FAQs.email')}`} className="font-semibold text-indigo-600 hover:text-indigo-500">
                {chunks}
              </Link>
            ),
          })}
        </p>
        <div className="mt-16">
          <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-16 sm:space-y-0 lg:grid-cols-3 lg:gap-x-10">
            {faqs.map((faq, faqIdx) => (
              <div key={faqIdx}>
                <dt className="text-lg font-semibold leading-6 text-gray-900">{faq.questionName}</dt>
                <dd className="mt-4 text-base leading-7 text-gray-600">{faq.acceptedAnswerText}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
